module.exports = __webpack_public_path__ + "img/refresh.4e1c3da6.svg";